import { PageStateStore } from './PageStateStore';
import { PageStateLiveUserState } from './PageStateLiveUserState';
import { PageStateService } from '@shared/user-state/PageStateService';
import { DialogConfirm } from '@shared/ui-native/Dialog';


/**
 * @author NikolaV
 */

export class PageStateFacade<T extends IPageState> {
    public readonly store: PageStateStore;
    public readonly handler: IPageStateHandler<T>;
    public readonly liveUserState: PageStateLiveUserState<T>;

    constructor(page: IPageStatePage, handler: IPageStateHandler<T>) {
        this.store = new PageStateStore(page);
        this.handler = handler;
        this.liveUserState = new PageStateLiveUserState(handler);
    }

    fetchStateAndRestoreWithProjectCheck = async (idOrUuid: number | string, fallbackToLiveState = true, askConfirmLoad = false): Promise<IPageState> => {
        const state = await PageStateService.fetchStateOrLiveState(idOrUuid, this.store.page, askConfirmLoad, fallbackToLiveState);
        if (state) {
            this.handler.restoreState(state);
        }
        return state;
    }

    fetchStateAndRestore = async (uuid: string, askConfirmLoad = false, stateName?: string): Promise<IPageState> => {
        const doLoad = async () => {
            this.store.loadingStateUuid = uuid;
            const state = await PageStateService.fetchItem(uuid, false);
            this.store.loadingStateUuid = null;
            if (state) {
                this.handler.restoreState(state);
            }
            return state;
        }

        if (askConfirmLoad) {
            // cant use native confirm(), it doesnt work on ios+webview
            DialogConfirm({
                msg: __('js_saved_views.load.load_saved_state_ask') + (stateName ? `: ${stateName}` : ''),
                type: 'success',
            }, doLoad);
        } else {
            return doLoad();
        }
    }

    createTemporaryState = async (): Promise<IPageState> => {
        const state: IPageState = await this.handler.getCurrentState(false);
        state.visibility = 'HIDDEN';
        return this.store.create(state);
    }
}
